import React from "react";

const Desription = () => {
    return(
        <div id = "description">
        <p>The following is the progress shown by the avid participators for the
            30 Days of Google Cloud Challenge. The Coordination being done by GDSC 
            IIIT Ranchi.
        </p>
        </div>
    );
};

export default Desription;